<template>
  <Dialog :title="$t('Enviar pedido')" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-slot:content>
      <ValidationObserver ref="form">
          <p>{{ $t("Se va a proceder a actualizar el stock de los productos del pedido.") }}</p>
          <p>{{ $t("Por favor, rellene las unidades enviadas y haga clic en guardar.") }}</p>

          <v-data-table
              :headers="tabla.headers"
              :items="tabla.items"
              :fixed-header="true"
              class="elevation-3"
              calculate-widths
              :no-data-text="$t('No hay datos')"
              :no-results-text="$t('No hay datos')"
              hide-default-footer
          >

            <template v-slot:item.actions="{ item }">
              <ValidationProvider :rules="{'required': true, 'integer': true, 'min_value': 0}"
                                      :name="$t('Unidades enviadas').toLowerCase()"
                                      v-slot="{ errors, classes }"
                  >
                    <div class="control" :class="classes">
                      <v-text-field
                          hide-details
                          v-model="item.unidades_enviadas"
                          type="number"
                          :outlined="true"
                          :dense="true"
                      >
                      </v-text-field>
                    </div>
                    <span class="error--text">{{ errors[0] }}</span>
                  </ValidationProvider>
            </template>
          </v-data-table>
      </ValidationObserver>
    </template>

    <!-- Acciones de la derecha del dialog -->
    <template v-slot:right-action>
      <v-btn @click="save" small class="primary">
        <v-icon small>mdi-content-save</v-icon>
        {{ $t('Guardar') }}
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: "FormEnviarPedido",
  props: ['value', 'item'],

  data: () => ({
    pedido: null,
    tabla: {
      headers: [],
      items: [],
    }
  }),

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },

  methods: {
    async save(){
        // Validamos el formulario
        const form_valid = await this.$refs.form.validate()
        if (!form_valid) return
        try {

          await this.$store.dispatch('proveedor/send_pedido_to_centro', {
              pedido_id: this.pedido.id,
              productos_enviados: this.pedido.lineas_pedido.map(linea => {
                return {
                  producto: linea.producto,
                  cantidad: linea.unidades_enviadas
                }
              })

          })
          this.$snotify.success(
            this.$t("Acción realizada con éxito"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
            this.$emit('on_save')
        } catch (err) {
          this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
    }
  },

  mounted() {
    this.pedido = {...this.item}
    // Establecemos por defecto las unidades enviadas a unidades pedidas
    this.pedido.lineas_pedido.forEach(linea => {
      linea.unidades_enviadas = linea.cantidad
    })
    this.tabla.headers = [
        { text: this.$t('Producto'), value: 'descripcion' },
        { text: this.$t('Unidades pedidas'), value: 'cantidad' },
        { text: this.$t('Unidades enviadas'), value: 'actions' },
    ]
    this.tabla.items = this.pedido.lineas_pedido
  },

  components: {
    ValidationProvider,
    ValidationObserver
  }
}
</script>
